import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';

import SubmitButton from 'components/ui/buttons/SubmitButton';
import AuthContext from 'providers/auth';
import AuthApi from 'api/auth';

const EmailForm = ({ email, setEmail }) => {
  const { t } = useTranslation();

  const auth = useContext(AuthContext);
  const [authenticating, setAuthenticating] = useState(false);
  const [message, setMessage] = useState({});

  if (!email) {
    return null;
  }

  const onSubmit = async e => {
    e.preventDefault();

    const code = document.getElementById('inputCode').value;

    try {
      setAuthenticating(true);
      const data = await AuthApi.validateCode(email, code);
      auth.signIn(data);
    } catch (error) {
      const status = error.status || error.response.status;
      if (status === 401) {
        setMessage({ type: 'error', description: t('messages.invalid_code') });
      } else {
        setMessage({ type: 'error', description: t('messages.unexpected_error') });
      }
    } finally {
      setAuthenticating(false);
    }
  };

  const renderMessage = () => {
    if (!message.type) {
      return null;
    }
    return (
      <div className="alert alert-danger mt-4" role="alert">
        {message.description}
      </div>
    );
  };

  return (
    <form className="mt-4" onSubmit={onSubmit}>
      <p>{t('signin.code_sent')}</p>

      <div className="form-group">
        <label htmlFor="inputCode">{t('columns.confirmation_code')}:</label>
        <input
          type="text"
          className="form-control"
          autoFocus
          disabled={authenticating}
          id="inputCode"
          placeholder={t('signin.form.code_input.placeholder')}
          required
        />
      </div>

      {renderMessage()}

      <div className="mt-4">
        <div>
          <SubmitButton loading={authenticating} className="btn btn-primary shadow form-control" tkey="keys.continue" />
        </div>

        <div className="form-group mt-4 text-center">
          <button className="btn btn-link" onClick={() => setEmail(null)}>
            {t('keys.back')}
          </button>
        </div>
      </div>
    </form>
  );
};

export default EmailForm;
